import { ILogLighting } from "../Types"
import { classNames } from "../Components"

interface NavigationLightsIconProps {
  className?: string;
  lighting: ILogLighting;
  title?: string;
}

const supportedLighting = new Set<ILogLighting>([
  ILogLighting.none,
  ILogLighting.triColorLights,
  ILogLighting.sailingRunningLights,
  ILogLighting.motoringRunningLights,
  ILogLighting.anchorLight,
  ILogLighting.anchorBall,
  ILogLighting.motoringCone,
]);

export const NavigationLightsIconData = {
  supports(lighting: ILogLighting | undefined): lighting is ILogLighting {
    return lighting != undefined && supportedLighting.has(lighting);
  },
};

function Lamp({ light, cx, cy }: { light: "port" | "starboard" | "white"; cx: number; cy: number }) {
  const fill = light === "white" ? "currentColor" : `var(--navigation-light-${light})`;
  return <circle className="NavigationLightsIcon-lamp" cx={cx} cy={cy} data-light={light} fill={fill} r="8" />;
}

export function NavigationLightsIcon({ className, lighting, title }: NavigationLightsIconProps) {
  return (
    <svg
      aria-hidden={title ? undefined : true}
      aria-label={title}
      className={classNames(["NavigationLightsIcon", `NavigationLightsIcon-${ILogLighting[lighting]}`, className])}
      role={title ? "img" : undefined}
      viewBox="0 0 100 100"
    >
      <path className="NavigationLightsIcon-frame" d="M50 8 Q56 8 60 15 L91 72 Q96 82 84 82 H16 Q4 82 9 72 L40 15 Q44 8 50 8 Z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="5" />
      {lighting === ILogLighting.triColorLights && (
        <>
          <Lamp cx={43} cy={32} light="port" />
          <Lamp cx={57} cy={32} light="starboard" />
        </>
      )}
      {(lighting === ILogLighting.sailingRunningLights || lighting === ILogLighting.motoringRunningLights) && (
        <>
          <Lamp cx={27} cy={69} light="port" />
          <Lamp cx={73} cy={69} light="starboard" />
        </>
      )}
      {lighting === ILogLighting.motoringRunningLights && <Lamp cx={50} cy={48} light="white" />}
      {lighting === ILogLighting.anchorLight && <Lamp cx={50} cy={29} light="white" />}
      {lighting === ILogLighting.anchorBall && (
        <circle className="NavigationLightsIcon-shape" cx={50} cy={48} data-shape="anchor-ball" fill="currentColor" r={10} />
      )}
      {lighting === ILogLighting.motoringCone && (
        <path className="NavigationLightsIcon-shape" d="M38 34 H62 L50 58 Z" data-shape="motoring-cone" fill="currentColor" />
      )}
    </svg>
  );
}
